export const currencies = [
    'EUR',
    'GBP',
    'KES',
    'UGX',
    'USD',
    'TZS'
];
